const MEAT = [
  "kuřecí",
  "vepřové",
  "hovězí",
  "krůtí",
  "ryba",
  "mořské plody",
  "krevety",
  "slanina",
  "bez masa"
];
const TYPE = ["slaný", "sladký"];
const COURSE = [
  "snídaně",
  "oběd",
  "večeře",
  "polévka",
  "salát",
  "příloha",
  "svačina"
];

const ICONS = {
  kuřecí: "🐤",
  krůtí: "🦃",
  ryba: "🐟",
  chobotnice: "🐙",
  "mořské plody": "🦀",
  králičí: "🐇",
  krevety: "🦐",
  hovězí: "🐄",
  vepřové: "🐷",
  skopové:"🐐",
  slanina:"🥓",

  salát: "🥗",
  polévka: "🥣",
  snídaně: "☀",
  večeře: "🕯️",
  oběd:"🕛️",

  sladký: "🍰",
  slaný: "🥨",

  káva: "☕",
  nápoj: "🥛"
};

export function tagIcon(tag) {
  return ICONS[tag] || null;
}

export function tagGroup(tag) {
  if (tag.charAt(0).toUpperCase() === tag.charAt(0)) {
    return "Stát";
  } else if (MEAT.includes(tag)) {
    return "Maso";
  } else if (COURSE.includes(tag)) {
    return "Chod";
  } else if (TYPE.includes(tag)) {
    return "Pokrm";
  } else {
    return "Další";
  }
}
